export const VOYAGE_ROUTES = Object.freeze({
	VOYAGE_OVERVIEW: '/voyages',
	VOYAGE_DETAIL: '/voyages/:id',
	VOYAGE_ACTIVITYLOG: '/voyages/:id/activityLog',
});
